import React, { Component } from 'react'
import Firebase from 'firebase';

const ICONS = [
    "bag", "bank", "bar-chart", "briefcase", "calendar", "cart", "check", "earth-globe", "id-card", "letter", "light-bulb", "notepad", "pencil", "school", "smartphone", "statistics", "test", "upload"
]

export default class listIcons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            icon: ""
        }
        this.setIcon = this.setIcon.bind(this);
    }

    componentWillMount() {
        var formRef = Firebase.database().ref("draft")
            .child(this.props.formId)
            .once('value')
            .then(resp => {
                this.setState({
                    icon: resp.val().icon ? resp.val().icon : ""
                })
            });
    }

    setIcon(i) {
        this.setState({ icon: i });
        this.props.setIcon(i);
    }

    render() {
        return (
            <div className="col-md-12">
                <div className="form-group row">
                    <div className="col-md-3" style={{ backgroundColor: "#FFF", border: "1px solid #cfd8dc", height: "300px" }}>
                        <div className="card-block ">
                            <div className="form-group">
                                {
                                    this.state.icon ?
                                        <div className="text-center">
                                            <h3 style={{ color: "#CCCCCC" }}>Icono del formulario</h3>
                                            <img src={'/public/iconos/' + this.state.icon + ".svg"} className="img-avatar" width="200" />
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8" style={{ backgroundColor: "#FFF", border: "1px solid #cfd8dc", marginLeft: "1%", paddingTop: "20px" }}>
                        <h3 style={{ color: "#CCCCCC" }}>Seleccione un icono</h3>
                        <hr />
                        <div className="form-group row">
                            {
                                ICONS.map((i) => (
                                    <div className="col-md-2 image" style={{ marginBottom: "10px", cursor: "pointer" }} onClick={() => { this.setIcon(i) }}>
                                        <img src={'/public/iconos/' + i + ".svg"} className="img-avatar" width="100" />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/forms/listIcons.js